"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ScapiFriendlyCaptchaApi = void 0;
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _utils = require("../utils");
class ScapiFriendlyCaptchaApi {
  constructor(config) {
    this.fetch = (0, _utils.createScapiFetch)(config, 'friendlycaptcha');
  }
  validateCaptcha(...args) {
    var _this = this;
    return (0, _asyncToGenerator2.default)(function* () {
      const url = `validate`;
      return _this.fetch(url, 'POST', args, args === null || args === void 0 ? void 0 : args[0].body);
    })();
  }
}
exports.ScapiFriendlyCaptchaApi = ScapiFriendlyCaptchaApi;